import {getFloorChoiceText} from "../../../real_estate/utils/get_floor_choice_text";
import {regionsTypesWithForSalePhrase} from "../../constants/regions_types_with_for_sale_phrase";
import {getHouseFilterMetaText} from "../../list/helpers/sub_type/meta/get_house_filter_meta_text";
import {getFloorChoiceByOfferListSubType} from "../../list/helpers/sub_type/transform/get_floor_choice_by_offer_list_sub_type";
import {isOfferListSubTypeValidFloorChoice} from "../../list/helpers/sub_type/validator/is_offer_list_sub_type_valid_floor_choice";
import {isOfferListSubTypeValidHouseFilter} from "../../list/helpers/sub_type/validator/is_offer_list_sub_type_valid_house_filter";
import {ISearchPhraseOptions} from "../../types/ISearchPhraseOptions";
import {ISearchPhraseParams} from "../../types/ISearchPhraseParams";
import {OfferType} from "../../types/OfferType";
import {convertToSearchPhraseParts} from "./convert_to_search_phrase_parts";

export function offerSearchPhraseBuilder(data: ISearchPhraseParams, options?: ISearchPhraseOptions): string {
    const searchPhraseParts = convertToSearchPhraseParts(data, options);
    const {sale, price, instalment, area, rooms, offerType} = searchPhraseParts;

    const locationName = convertToLocationName(data);

    const restSearchPhrasePartsDefault = [price, instalment, area].filter((value) => typeof value === "string");

    const restSearchPhraseParts = restSearchPhrasePartsDefault.join(", ");

    if (data.offerListSubType && isOfferListSubTypeValidFloorChoice(data.offerListSubType)) {
        const floorChoice = getFloorChoiceByOfferListSubType(data.offerListSubType);
        const floorText = getFloorChoiceText(floorChoice);

        return `${offerType} ${floorText} ${locationName}`;
    }

    if (data.offerListSubType && isOfferListSubTypeValidHouseFilter(data.offerListSubType)) {
        const houseFilterText = getHouseFilterMetaText(data.offerListSubType);

        return `${offerType} ${houseFilterText} ${locationName}`;
    }

    const isMultiRegion = !!data.regions && data.regions.length > 1;
    const isCityOrDistrict = !!data.regions && data.regions.length > 0 && regionsTypesWithForSalePhrase.includes(data.regions[0].type);
    const isSingleRegionWithoutCommercial = !isMultiRegion && isCityOrDistrict && (data.type === OfferType.FLAT || data.type === OfferType.HOUSE);

    const locationPriority = data.is_luxury || data.price_lower_than_average || data.construction_end_date === "0" || isSingleRegionWithoutCommercial;
    const roomsPriority = !options?.isTitle && !options?.isMetaDescription;

    if (locationPriority && !roomsPriority) {
        return smartJoin(offerType, locationName, sale, restSearchPhraseParts, rooms);
    }

    if (Boolean(options?.isTitle) && isSingleRegionWithoutCommercial) {
        return smartJoin(offerType, restSearchPhraseParts, rooms, locationName);
    }

    if (Boolean(options?.isTitle) || Boolean(options?.isMetaDescription)) {
        return smartJoin(offerType, restSearchPhraseParts, rooms, locationName);
    }

    return smartJoin(offerType, rooms, sale, locationName, restSearchPhraseParts);
}

/*
 * locationName may be:
 *     -empty string
 *     -single locationa e.g. " Warszawa" or " mazowieckie" (city/county/voivodeship neme)
 *     -multiple location e.g "- Warszawa, mazowieckie - Wrocław, dolnośląskie"
 */
function convertToLocationName(data: ISearchPhraseParams) {
    if (data.regionName) {
        return ` ${data.regionName}`;
    }

    return "";
}

/**
 * Smart spacing utility that ensures proper spacing between text segments
 * without creating double spaces or missing spaces
 */
function smartJoin(...segments: (string | undefined | null)[]): string {
    return segments
        .filter((segment) => segment && segment.trim().length > 0)
        .map((segment) => segment!.trim())
        .join(" ");
}
